import React, { useEffect, useRef } from 'react';

import './PaperlessTerms.scss';
import { PAPERLESS_TERMS_MODAL } from '../../../../redux/modules/modals/modals.module';
import Button from '../../../Shared/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { getPaperlessTermsAndConditons } from '../../../../redux/modules/user/Paperless/paperlessSetting.module';
import Loader from '../../../Shared/Loader/Loader';

const PaperlessTerms = ({ closeModal }) => {
  const dispatch = useDispatch();
  const { termsAndConditions, isLoading } = useSelector(
    (state) => state.paperlessSetting
  );
  const myRef = useRef();

  useEffect(() => {
    try {
      if (!termsAndConditions) {
        const getTermsData = () => {
          dispatch(getPaperlessTermsAndConditons());
        };
        getTermsData(); /*.then((r) => {
          //myRef.current.innerHTML = r;
        });*/
      } else {
        myRef.current.innerHTML = termsAndConditions;
      }
    } catch (e) {
      console.log(e);
    }
  }, [dispatch, termsAndConditions, myRef]);
  if (isLoading) {
    return <Loader isVisible={true} />;
  }
  return (
    <div className="paperless-terms-container" id="e2e-paperless-terms">
      <section ref={myRef}> </section>
      {myRef.current && (
        <div className="paperless-terms-button-container">
          <Button
            id="paperless-terms-modal-close"
            buttonType="primary"
            type="button"
            onClick={() => closeModal(PAPERLESS_TERMS_MODAL)}
            stylename="close-button"
          >
            Close
          </Button>
        </div>
      )}
    </div>
  );
};
export default PaperlessTerms;
